"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ThemeProvider = require("../ThemeProvider");
/**
 * Generates a label string for a variant based on the provided key and value.
 *
 * @param {string} key - The name of the variant.
 * @param {*} value - The value of the variant. If it's a string, it will be appended to the key.
 * @returns {string} The formatted variant label (e.g., "color: red" or "size").
 */
const getVariantLabel = (key, value) => `${key}${typeof value === 'string' ? `: ${value}` : ''}`;

/**
 * Retrieves the variant options for a given component from the theme.
 *
 * @param {string} componentName - The name of the component to get variants for.
 * @returns {Array<Array>} An array of variant tuples. Each tuple contains:
 *   - {string|undefined} The variant key (e.g., 'size', 'color', or undefined for default).
 *   - {string|undefined} The variant value (e.g., 'small', 'primary', or undefined for default).
 *   - {string} The human-readable label for the variant.
 *   Returns [['default', {}]] if no componentName is provided.
 * @throws {Error} If the theme does not define appearances for the given component.
 */
const useVariants = componentName => {
  const theme = (0, _ThemeProvider.useTheme)();
  if (!componentName) return [['default', {}]];
  const {
    appearances
  } = (0, _ThemeProvider.getComponentTheme)(theme, componentName);
  if (!appearances) {
    throw new Error(`Theme ${theme.metadata?.name} does not have any appearances set for ${componentName}`);
  }
  const variants = Object.entries(appearances).reduce((pairs, _ref) => {
    let [key, {
      values,
      type
    } = {}] = _ref;
    return type === 'variant' ? [...pairs, ...values.map(value => [key, value, getVariantLabel(key, value)])] : pairs;
  }, [[undefined, undefined, 'default style']]);
  return variants;
};
var _default = exports.default = useVariants;